// Shared input shape for the Progress dashboard math helpers
// (progressTierOne / progressTierTwo / progressTierThree).
//
// A SessionResult paired with the wall-clock time of its source
// Session. SessionResult.computedAt is the cache-write time, not the
// workout time — windowing math needs the actual session start. Callers
// join with the Session envelope before passing in.
import type { SessionResult } from "./schemas/sessionResult.js";

export type TimedSessionResult = {
  result: SessionResult;
  startedAtMs: number;
};
